export const blogCategoryUrl = slug => `/blog/category/${slug}/`;

export const blogPostUrl = slug => `/blog/${slug}/`;
